import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { type ComponentProps } from 'react';

import { cn } from '@/lib/utils';

/*
 * shadcn/ui Separator — generated primitive built on Radix Separator.
 * Defaults to a decorative horizontal rule using `--border`.
 */
function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  ...props
}: ComponentProps<typeof SeparatorPrimitive.Root>) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'bg-border shrink-0',
        'data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full',
        'data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className,
      )}
      {...props}
    />
  );
}

export { Separator };
